<template>
  <div>
    <v-card class="pa-2 ma-0">
      <!-- Msg no dati -->
      <v-card
        flat
        tile
        class="py-2 px-0 has-border-bottom"
        v-if="this.dati.length == 0 && attesa==false"
      >Nessun dato trovato.</v-card>

      <!-- Switch raggruppa bolle -->
      <v-switch
        v-model="raggruppaBolle"
        label="Raggruppa bolle"
        hide-details
        class="pb-2"
        v-on:change="resetDati(false)"
      ></v-switch>

      <!-- Attesa -->
      <v-progress-circular
        indeterminate
        color="primary"
        v-if="attesa"
        style="display: flex; margin: 0 auto"
      ></v-progress-circular>

      <v-expansion-panel flat class="has-border-bottom" v-model="panelRiferimento">
        <v-expansion-panel-content
          v-for="(item,j) in dati"
          :key="j"
          @click.native="caricaDatiDettaglio(item.cdContatto, j)"
        >
          <template v-slot:header>
            <div>{{item.ragioneSociale}}</div>
          </template>

          <!-- Attesa -->
          <v-progress-circular
            indeterminate
            color="primary"
            v-if="attesaDettaglio"
            style="display: flex; margin: 0 auto"
          ></v-progress-circular>

          <!------------------
          --- BOLLE (v-if) ---
          ------------------->
          <v-expansion-panel
            flat
            class="has-border-bottom"
            v-model="panelBolle"
            v-if="raggruppaBolle"
          >
            <v-expansion-panel-content
              v-for="(bolle,z) in datiBolle"
              :key="z"
              @click.native="caricaDatiArticoli(item.cdContatto, bolle.nrBolla)"
              style="background-color:#EEEEEE;"
            >
              <template v-slot:header>
                <div>
                  Nr. {{bolle.nrBolla}} del {{$functions.formatISODate(bolle.dtBolla)}}
                  <v-btn @click.stop.prevent="riceviBollaCompleta(bolle)" icon small>
                    <v-icon>flash_on</v-icon>
                  </v-btn>
                </div>
              </template>

              <!-- Lista articoli -->
              <articoli
                :itemsArticoli="getDettaglio"
                @aggiornaDati="aggiornaStatoEvasione"
                :codeBar="codeBarArticolo"
                :panelRiferimento="parseInt(panelBolle)"
                :tipoEvasione="'ricevimento'"
                v-if="panelRiferimento===j && panelBolle===z"
              ></articoli>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <!-----------------------
          --- ARTICOLI (v-else) ---
          ------------------------>
          <div v-else>
            <articoli
              :itemsArticoli="getDettaglio"
              @aggiornaDati="aggiornaStatoEvasione"
              :codeBar="codeBarArticolo"
              :panelRiferimento="parseInt(panelRiferimento)"
              :tipoEvasione="'ricevimento'"
              v-if="panelRiferimento===j"
            ></articoli>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-card>
  </div>
</template>


<script>
import { get_ricevimento, riceviBolla } from "@/api/api.js";
import Articoli from "@/components/articoli/Articoli.vue";

export default {
  components: {
    Articoli
  },

  data: () => ({
    dati: [],
    datiDettaglio: [],
    datiBolle: [],

    attesa: false,
    attesaDettaglio: false,

    codeBarArticolo: {},

    panelRiferimento: null,
    panelRifSel: -1,

    panelBolle: null,
    panelBollaSel: -1,

    raggruppaBolle: true
  }),

  methods: {
    caricaDati() {
      this.attesa = true;

      // Reset
      this.resetDati(true);

      get_ricevimento("")
        .then(res => {
          //console.log(res.data);

          this.dati = res.data;
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => (this.attesa = false));
    },

    caricaDatiDettaglio(cdContatto, panelRifIndex) {
      // -----------------
      // Gestione pannello
      if (this.panelRiferimento == null) {
        // Reset
        this.datiDettaglio = [];
        this.panelRifSel = -1;

        this.datiBolle = [];
        this.panelBollaSel = -1;
        this.panelBolle = null;
        return;
      }
      if (this.panelRiferimento !== panelRifIndex) return;
      if (this.panelRifSel == this.panelRiferimento) return;

      this.panelRifSel = this.panelRiferimento;
      // -----------------

      // Controllo tipo caricamento
      if (this.raggruppaBolle) {
        this.caricaDatiBolle(cdContatto);
      } else {
        this.caricaDatiArticoli(cdContatto, 0);
      }
    },

    caricaDatiArticoli(cdContatto, nrBolla) {
      // Controllo espansione bolle
      if (nrBolla) {
        // -----------------
        // Gestione pannello

        if (this.panelBolle == null) {
          // Reset
          this.panelBollaSel = -1;
          return;
        }

        if (this.panelBollaSel == this.panelBolle) return;
        this.panelBollaSel = this.panelBolle;
        //  -----------------
      }

      // Reset
      this.datiDettaglio = [];

      // Attesa
      this.attesaDettaglio = true;

      get_ricevimento(cdContatto + "/" + nrBolla)
        .then(res => {
          this.datiDettaglio = res.data;
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.attesaDettaglio = false;
        });
    },

    caricaDatiBolle(cdContatto) {
      // Reset
      this.datiBolle = [];
      this.panelBollaSel = -1;
      this.panelBolle = null;

      get_ricevimento("raggruppabolle/" + cdContatto)
        .then(res => {
          this.datiBolle = res.data;
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {});
    },

    aggiornaStatoEvasione(row, idUnivoco) {
      // Ricavo la riga
      let r = this.datiDettaglio.find(f => f.idUnivoco == idUnivoco);

      // Viene attivata la computed getDettaglio
      r.statoEvasione = row.statoEvasione;
      r.qtEvasaStoccata = row.qtEvasaStoccata;
      r.qtRimanenza = row.qtRimanenza;
      r.parziale = row.parziale;
      r.qtaScaffale = row.qtaScaffale;
    },

    resetDati(pulisci) {
      // Reset
      if (pulisci) this.dati = [];

      this.datiDettaglio = [];
      this.datiBolle = [];

      this.panelRiferimento = null;
      this.panelRifSel = -1;

      this.panelBolle = null;
      this.panelBollaSel = -1;
    },

    riceviBollaCompleta(item) {
      // Messaggio di conferma ricevimento rigo
      this.$confirm
        .open("Ricevi", "Vuoi ricevere tutta la bolla ?")
        .then(confirm => {
          if (!confirm) return;

          debugger;

          let par = {
            NrBolla: item.nrBolla,
            CdContatto: item.cdContatto,
            utente: this.$store.getters["user/getUser"]
          };

          riceviBolla(par)
            .then(res => {
              //console.log(res.data);

              this.caricaDatiBolle(item.cdContatto);
            })
            .catch(err => {
              console.log(err);
            })
            .finally(() => (this.attesa = false));
        })
        .catch(err => {
          console.log(this.$functions.getErrorMsg(err));
        });
    }
  },

  mounted() {
    this.caricaDati();
  },

  computed: {
    getCodebar() {
      return this.$store.getters["app/getCodebar"];
    },

    getDettaglio() {
      return this.datiDettaglio.filter(f => f.statoEvasione == 0);
    }
  },

  watch: {
    getCodebar(v) {
      // --- Ricerca x articolo ---
      this.codeBarArticolo = v;
    },
    panelRiferimento() {
      //console.log("watch panelRiferimento")

      // NOTA: quando cambia pannello, resetto l'articolo selezionato
      this.$store.commit("app/resetArticoloSelezionato");
    }
  }
};
</script>
